import { overlayStrategemFadeMs } from './overlayStrategemTiming';

/** Strategem 315 (Unethical Experiment): fade-in target art on sacrificed friendly unit */
export const UNETHICAL_TARGET_IMAGE_PATH = '/images/unethical_target.png';
export const UNETHICAL_SOUND_PATH = '/sounds/unethical.mp3';
export const UNETHICAL_TARGET_FADE_DURATION_MS = overlayStrategemFadeMs(315);
/** Max width/height (px) for the overlay image — explicit px so size isn’t dominated by vw or intrinsic PNG dimensions */
export const UNETHICAL_TARGET_OVERLAY_MAX_PX = 72;
